import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLayout = _resolveComponent("MainLayout")!
  const _component_PublicLayout = _resolveComponent("PublicLayout")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createBlock(_component_MainLayout, { key: 0 }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }))
    : (_openBlock(), _createBlock(_component_PublicLayout, { key: 1 }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }))
}